<div class="facet-paging-container">
  <capra-icon-button
    class="facet-paging-icon-button"
    icon="icon-pagination-first"
    size="small"
    aria-label="First page"
    data-test="first-page-button"
    [disabled]="isFirstPage"
    (clicked)="first()"
  ></capra-icon-button>
  <capra-icon-button
    class="facet-paging-icon-button"
    icon="icon-pagination-previous"
    size="small"
    aria-label="Previous page"
    data-test="previous-page-button"
    [disabled]="!hasPrevious"
    (clicked)="previous()"
  ></capra-icon-button>
  <div class="go-to-page hide-go-to-page">
    <label
      ><span>Page</span>
      <input
        type="number"
        data-test="page-number-input"
        class="form-control form-control-sm"
        [ngModel]="currentPage"
        (ngModelChange)="pageInputChange($event)"
        min="1"
        [max]="totalPages"
      />
      <span>of {{ totalPages | number }}</span>
    </label>
  </div>
  <capra-icon-button
    class="facet-paging-icon-button"
    icon="icon-pagination-next"
    size="small"
    aria-label="Next page"
    data-test="next-page-button"
    [disabled]="!hasNext"
    (clicked)="next()"
  ></capra-icon-button>
  <capra-icon-button
    class="facet-paging-icon-button"
    icon="icon-pagination-last"
    size="small"
    aria-label="Last page"
    data-test="last-page-button"
    [disabled]="isLastPage"
    (clicked)="last()"
  ></capra-icon-button>
  <div class="page-meta-info hide-meta-info">
    <capra-icon
      icon="icon-info-outline"
      capraTooltip
      [tooltipContent]="infoTooltipContent"
      [tooltipDelay]="[1000, 0]"
      tooltipPlacement="top"
      [tooltipContentIsHtml]="true"
    ></capra-icon>
    <label
      ><span>{{ pagingMetaInfo }}</span></label
    >
  </div>
</div>
